import { PRODUCT_STATUS } from '../constants/productStatusOptions';

export const getProductsByStatus = (products = [], status) => {
	if (status === PRODUCT_STATUS.INACTIVE) {
		return products.filter((product) => product.is_active === false);
	}

	if (status === PRODUCT_STATUS.ACTIVE) {
		return products.filter((product) => product.is_active !== false);
	}

	return products;
};
